/**
 * `true` when the running device is touch-primary / mobile. Primary
 * signal: `navigator.userAgentData.mobile` (Chromium User-Agent Client
 * Hints — authoritative on Chrome/Edge Android where it's `true` and
 * on Chrome/Edge desktop where it's `false`). Fallback for Safari /
 * Firefox / older browsers: the standard CSS media-query combo
 * `(pointer: coarse)` + `(hover: none)` identifies a touch-primary
 * device without a hovering pointer — true for phones and most
 * tablets, false for desktops regardless of touchscreen presence
 * (a MacBook trackpad is `(pointer: fine) (hover: hover)`).
 *
 * Lives in its own file so BookShareSheet.tsx stays compliant with
 * `react-refresh/only-export-components` (one exported React component
 * per file, plus the component's required test exports).
 */
export function isMobileDevice(): boolean {
  if (typeof navigator !== 'undefined' && 'userAgentData' in navigator) {
    const uad = (navigator as unknown as { userAgentData?: { mobile?: boolean } }).userAgentData;
    if (typeof uad?.mobile === 'boolean') return uad.mobile;
  }
  if (typeof window !== 'undefined' && typeof window.matchMedia === 'function') {
    const coarse = window.matchMedia('(pointer: coarse)').matches;
    const noHover = window.matchMedia('(hover: none)').matches;
    return coarse && noHover;
  }
  return false;
}
